import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'

import { MenuItems, MenuItem, MenuText, Collapse } from './styles'

import { Icon } from 'bd-web-components'

import {
  WHITE,
  BLACK,
} from 'bd-web-components/src/utils/dash-colors'

import { isRouteActive } from '../../utils/router'
import { useEventMenu } from '../../hooks/navigation'
import useBdApp from '../../hooks/bdapp/useBdApp'
import useBdAppEventBus from '../../hooks/bdapp/useBdAppEventBus'
import { getDashColor } from '../../styles'

interface MenuProps {
  props?: any
}

const Menu: React.FC<MenuProps> = ({ props = [] }) => {
  const [collapsed, setCollapsed] = useState<any>(null)
  const location = useLocation()
  const { id } = useParams<{ id: string }>()

  const menuItems = useEventMenu(id)
  const { isNative } = useBdApp()
  const { publish } = useBdAppEventBus()

  const getCurrentPath = (path: string) => isRouteActive(location, path)

  const collapsePress = (index: number) => {
    let value: any = null

    if (collapsed !== index) {
      value = index
    }

    setCollapsed(value)
  }

  // Debounced publish for native drawer items
  useEffect(() => {
    const drawerCreate: Array<{
      id: string
      icon: string
      title: string
      url: string
    }> = []

    menuItems.forEach((m: any) => {
      // Top-level items can opt-in too if needed
      if (m.drawer && m.id) {
        drawerCreate.push({
          id: m.id,
          icon: m.drawerIcon || m.icon,
          title: m.title,
          url: new URL(m.path, window.location.origin).href,
        })
      }

      if (m.children && m.children.length > 0) {
        m.children.forEach((c: any) => {
          if (c.drawer && c.id) {
            drawerCreate.push({
              id: c.id,
              icon: c.drawerIcon || m.icon,
              title: c.title,
              url: new URL(c.path, window.location.origin).href,
            })
          }
        })
      }
    })

    // Debounce logic
    const handler = setTimeout(() => {
      publish('drawer-create', drawerCreate)
    }, 1000)
    return () => clearTimeout(handler)
  }, [menuItems, publish])

  if (isNative) return null

  return (<>
    <MenuItems>
      {menuItems.map((menu: any, index: any) => {
        let menuActive: boolean = getCurrentPath(menu.path)
        let menuChildrenActive: boolean = false

        if (menu.children !== undefined && menu.children?.length > 0) {
          menuChildrenActive =
            menu.children.filter((value: any) => {
              if (value.activePaths && value.activePaths.length > 0) {
                return (
                  value.activePaths.filter((activePath: any) =>
                    Boolean(getCurrentPath(activePath))
                  ).length > 0
                )
              }

              return Boolean(getCurrentPath(value.path))
            }).length > 0
        }

        if (menu.activePaths && menu.activePaths.length > 0) {
          menuActive =
            menu.activePaths.filter((activePath: any) =>
              Boolean(getCurrentPath(activePath))
            ).length > 0
        }

        return (
          <>
            {!menu.children?.length && (
              <>
                <Link to={menu.path}>
                  <MenuItem className={menuActive ? 'active' : ''}>
                    <Icon
                      width={18}
                      height={18}
                      iconName={menu.icon}
                      fill={menuActive ? WHITE : BLACK}
                      classes="add-account-chevron"
                    />
                    <MenuText>{menu.title}</MenuText>
                  </MenuItem>
                </Link>
              </>
            )}

            {menu.collapse && menu.children?.length && (
              <>
                <MenuItem
                  className={menuChildrenActive ? 'active' : ''}
                  onClick={() => collapsePress(index)}
                >
                  <Icon
                    width={18}
                    height={18}
                    iconName={menu.icon}
                    fill={menuChildrenActive ? WHITE : BLACK}
                    classes="add-account-chevron"
                  />
                  <MenuText>{menu.title}</MenuText>
                  <Icon
                    width={7}
                    height={7}
                    iconName={
                      menuChildrenActive || collapsed === index
                        ? 'downArrow'
                        : 'rightArrow'
                    }
                    fill={menuChildrenActive ? WHITE : BLACK}
                    classes="text-right"
                  />
                </MenuItem>

                <Collapse
                  style={{
                    maxHeight:
                      menuChildrenActive || collapsed === index ? 200 : 0,
                  }}
                >
                  <div>
                    {menu.children.map((sub: any) => {
                      let active = getCurrentPath(sub.path)

                      if (sub.activePaths && sub.activePaths.length > 0) {
                        active =
                          sub.activePaths.filter((activePath: any) =>
                            Boolean(getCurrentPath(activePath))
                          ).length > 0
                      }

                      return (
                        <>
                          <Link to={sub.path}>
                            <MenuItem
                              className={`sub ${active ? 'active' : ''}`}
                            >
                              <Icon
                                width={12}
                                height={12}
                                iconName={'ellipse'}
                                fill={
                                  active ? getDashColor('SECONDARY_BLUE_05', 'SECONDARY_COLOR') : getDashColor('SECONDARY_BLUE_09', 'TEXT_DARK_COLOR')
                                }
                                classes="add-account-chevron"
                              />
                              <MenuText>{sub.title}</MenuText>
                            </MenuItem>
                          </Link>
                        </>
                      )
                    })}
                  </div>
                </Collapse>
              </>
            )}
          </>
        )
      })}
    </MenuItems>
  </>)
}

export default Menu
